module.exports = __webpack_public_path__ + "media/images/front/img_movie_feature05-e31b17fb520035afa9a124219177afd1.jpg";